import { render } from "./StatistiqueMpostPage.vue?vue&type=template&id=6ee4f614&ts=true"
import script from "./StatistiqueMpostPage.vue?vue&type=script&lang=ts"
export * from "./StatistiqueMpostPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__